const pt = {
  meta: {
    home: { title: 'F&L Group — Criamos imagens, experiências e marcas que ficam', desc: 'Grupo criativo português com duas áreas especializadas: F&L Media (fotografia, vídeo, marketing, websites) e F&L Souvenir (fotografia souvenir).' },
    media: { title: 'F&L Media — Fotografia, Vídeo, Marketing e Websites', desc: 'Conteúdo que dá forma às tuas ideias. Produção de fotografia, vídeo, marketing e websites para empresas, marcas e projetos.' },
    souvenir: { title: 'F&L Souvenir — Fotografia Souvenir para Espaços de Lazer', desc: 'Transformamos momentos em recordações. Soluções de fotografia souvenir para espaços de lazer, turismo e entretenimento.' },
    portfolio: { title: 'Portfólio — F&L Group', desc: 'Uma seleção de trabalhos das duas áreas da F&L Group: F&L Media e F&L Souvenir.' },
    about: { title: 'Sobre Nós — F&L Group', desc: 'Duas pessoas. Quatro anos de experiência. Um grupo em crescimento. Conhece Miguel Martins e Rafael Ribeiro.' },
    contact: { title: 'Contactos — F&L Group', desc: 'Vamos criar algo juntos? Fala connosco sobre o teu projeto ou parceria.' },
    privacy: { title: 'Política de Privacidade — F&L Group', desc: 'Política de Privacidade da F&L Group.' },
    cookies: { title: 'Política de Cookies — F&L Group', desc: 'Política de Cookies da F&L Group.' },
    terms: { title: 'Termos e Condições — F&L Group', desc: 'Termos e Condições da F&L Group.' },
  },
  nav: {
    home: 'Início', media: 'F&L Media', souvenir: 'F&L Souvenir',
    portfolio: 'Portfólio', about: 'Sobre Nós', contact: 'Contactos',
    cta: 'Falar Connosco', openMenu: 'Abrir menu', closeMenu: 'Fechar menu',
  },
  cursor: { view: 'VER', open: 'ABRIR', play: 'PLAY', explore: 'EXPLORAR', contact: 'CONTACTO', viewProject: 'VER PROJETO' },
  home: {
    kicker: 'Grupo Criativo · Portugal',
    titleA: 'Criamos imagens,',
    titleB: 'experiências e marcas',
    titleC: 'que ficam.',
    sub: 'Um grupo criativo com duas áreas especializadas.',
    scroll: 'Scroll para explorar',
    media: { tag: 'Conteúdo que dá forma às tuas ideias.', desc: 'Produzimos fotografia, vídeo, marketing e websites para empresas, marcas e projetos.', cta: 'Explorar F&L Media' },
    souvenir: { tag: 'Transformamos momentos em recordações.', desc: 'Criamos soluções de fotografia souvenir para espaços de lazer, turismo e entretenimento.', cta: 'Explorar F&L Souvenir' },
    groupKicker: 'O Grupo',
    groupTitle: 'Duas marcas. Uma visão.',
    groupText: 'A F&L Group reúne a experiência adquirida ao longo dos últimos quatro anos em fotografia, vídeo e comunicação — hoje organizada em duas áreas especializadas que se complementam.',
    statYears: 'Anos de experiência',
    statBrands: 'Marcas especializadas',
    statAreas: 'Áreas criativas',
    statVision: 'Visão partilhada',
    aboutCta: 'Conhecer a F&L Group',
    b2b2cKicker: 'O Modelo',
    b2b2cTitle: 'Um negócio, dois públicos.',
    b2bTitle: 'B2B — Empresas & Espaços',
    b2bText: 'Trabalhamos diretamente com empresas, marcas e projetos através da F&L Media, e com espaços de lazer, turismo e entretenimento através da F&L Souvenir — soluções à medida de cada parceiro.',
    b2cTitle: 'B2C — Visitantes & Público',
    b2cText: 'Através da F&L Souvenir, criamos recordações fotográficas personalizadas para quem visita cada espaço — o público final que leva consigo o momento.',
    contactKicker: 'Contactos',
    contactTitle: 'Vamos criar algo juntos?',
    contactMediaBrand: 'F&L Media',
    contactMediaTitle: 'Pedir orçamento',
    contactMediaText: 'Fotografia, vídeo, marketing e websites para empresas, particulares, eventos e projetos pessoais.',
    contactSouvenirBrand: 'F&L Souvenir',
    contactSouvenirTitle: 'Propor parceria',
    contactSouvenirText: 'Experiências fotográficas e recordações personalizadas para espaços turísticos e de lazer.',
    marquee: ['Fotografia', 'Vídeo', 'Marketing', 'Websites', 'Experiências', 'Souvenir', 'Conteúdo', 'Marcas'],
  },
  media: {
    kicker: 'F&L Media',
    title: 'Conteúdo que dá forma às tuas ideias.',
    desc: 'Criamos conteúdos visuais e soluções digitais para empresas, marcas e projetos que procuram comunicar melhor.',
    servicesKicker: 'Serviços',
    servicesTitle: 'O que fazemos',
    services: [
      { title: 'Fotografia', desc: 'Fotografia profissional para marcas, empresas, produtos, eventos, lifestyle e projetos.' },
      { title: 'Vídeo', desc: 'Produção de vídeo para empresas, marcas, eventos, redes sociais e projetos audiovisuais.' },
      { title: 'Marketing', desc: 'Criação de conteúdos e soluções de comunicação adaptadas a cada marca e objetivo.' },
      { title: 'Websites', desc: 'Criação de websites modernos, responsivos e adaptados à identidade de cada projeto.' },
    ],
    workKicker: 'Portfólio',
    workTitle: 'Trabalhos F&L Media',
    workCta: 'Ver portefólio',
    filters: { all: 'Todos', photo: 'Foto', video: 'Vídeo', marketing: 'Marketing', web: 'Web' },
    ctaTitle: 'Tens um projeto em mente?',
    galleryTitle: 'Kartódromo Internacional de Braga',
    galleryText: 'Cobertura fotográfica em pista.',
    ctaText: 'Conta-nos a tua ideia e recebe uma proposta à medida.',
    ctaButton: 'Pedir Orçamento',
  },
  souvenir: {
    kicker: 'F&L Souvenir',
    title: 'Transformamos momentos em recordações.',
    desc: 'Criamos e operamos soluções de fotografia souvenir para espaços de lazer, turismo e entretenimento.',
    stepsKicker: 'Como Funciona',
    stepsTitle: 'Da experiência à recordação',
    steps: [
      { title: 'Captamos', desc: 'Fotografamos os visitantes durante a experiência.' },
      { title: 'Personalizamos', desc: 'Criamos fotografias e capas temáticas relacionadas com o espaço.' },
      { title: 'Produzimos', desc: 'Disponibilizamos fotografias impressas e/ou digitais.' },
      { title: 'Recordamos', desc: 'O visitante leva consigo uma recordação personalizada da experiência.' },
    ],
    venuesKicker: 'Espaços & Experiências',
    venuesTitle: 'Onde podemos criar memórias',
    venueNote: 'Atualmente a operar num kartódromo — e preparados para levar a experiência a outros espaços.',
    venueActive: 'Em operação',
    venues: ['Karting', 'Surf', 'Parques', 'Zoológicos', 'Oceanários', 'Parques Aquáticos', 'Parques de Aventura', 'Turismo', 'Outras Experiências'],
    coversKicker: 'Capas Temáticas',
    coversTitle: 'Cada espaço tem uma história. A fotografia também.',
    coversText: 'Criamos capas e elementos gráficos alusivos à identidade e experiência de cada espaço, transformando uma fotografia numa verdadeira recordação.',
    coversFlow: ['Fotografia', 'Capa Personalizada', 'Souvenir'],
    coversExample: 'Do momento à recordação impressa',
    b2bKicker: 'Para Espaços Parceiros',
    b2bTitle: 'Mais do que fotografias. Uma experiência integrada.',
    benefits: [
      { title: 'Mais valor em cada visita', desc: 'Uma experiência fotográfica integrada que enriquece a visita e cria memórias personalizadas.' },
      { title: 'Maior valor para o visitante', desc: 'Uma recordação que prolonga a experiência para lá da visita.' },
      { title: 'Recordação personalizada', desc: 'Cada fotografia é enquadrada na identidade do espaço.' },
      { title: 'Conteúdo associado ao espaço', desc: 'Material visual que reforça a marca do parceiro.' },
      { title: 'Operação adaptada ao parceiro', desc: 'Funcionamento ajustado à realidade e ao ritmo de cada espaço.' },
      { title: 'Imagem profissional', desc: 'Equipa, equipamento e acabamentos de nível profissional.' },
    ],
    workKicker: 'Portfólio',
    workTitle: 'Trabalhos F&L Souvenir',
    filters: { all: 'Todos', leisure: 'Espaços de Lazer', tourism: 'Turismo', souvenir: 'Fotografia Souvenir', covers: 'Capas Temáticas' },
    ctaTitle: 'Tens um espaço de lazer ou turismo?',
    ctaText: 'Vamos conversar sobre como criar uma nova experiência para os teus visitantes.',
    ctaButton: 'Quero Ser Parceiro',
  },
  portfolio: {
    kicker: 'Portfólio',
    title: 'O Nosso Trabalho',
    desc: 'Uma seleção de projetos das duas áreas da F&L Group.',
    empty: 'Sem projetos nesta categoria de momento.',
    notFound: 'Projeto não encontrado',
  },
  project: {
    back: 'Voltar ao portefólio',
    next: 'Próximo projeto',
    about: 'Sobre o projeto',
    objective: 'O objetivo',
    challenge: 'O desafio',
    whatWeDid: 'O que fizemos',
    gallery: 'Galeria',
    results: 'Resultado',
    client: 'Cliente',
  },
  about: {
    kicker: 'Sobre Nós',
    titleA: 'Duas pessoas.',
    titleB: 'Quatro anos de experiência.',
    titleC: 'Um grupo em crescimento.',
    text: 'A F&L Group nasceu da experiência adquirida ao longo dos últimos quatro anos nas áreas da fotografia, vídeo e comunicação. Hoje, essa experiência está organizada em duas áreas especializadas: F&L Media e F&L Souvenir.',
    foundersKicker: 'Fundadores',
    foundersTitle: 'Quem está por trás da F&L Group',
    founders: [
      { name: 'Miguel Martins', role: 'Co-Fundador' },
      { name: 'Rafael Ribeiro', role: 'Co-Fundador' },
    ],
    timelineKicker: 'A Nossa Evolução',
    timelineTitle: '2022 — Hoje',
    timelineNote: 'Espaço reservado para os marcos reais da empresa — sem inventar números, prémios ou conquistas.',
    timelinePlaceholder: 'Marco a adicionar',
    cta: 'Trabalhar connosco',
  },
  contact: {
    kicker: 'Contactos',
    title: 'Vamos criar algo juntos?',
    desc: 'Escolhe a área certa e conta-nos o que tens em mente.',
    generalEmailLabel: 'Email geral',
    phoneLabel: 'Telefone',
    whatsappCta: 'Falar no WhatsApp',
    mediaTab: 'F&L Media',
    mediaTag: 'Fotografia · Vídeo · Marketing · Websites',
    mediaCta: 'Pedir Orçamento',
    souvenirTab: 'F&L Souvenir',
    souvenirTag: 'Espaços de lazer · Turismo · Fotografia souvenir · Parcerias',
    souvenirCta: 'Quero Ser Parceiro',
    form: {
      name: 'Nome', email: 'Email', phone: 'Telefone (opcional)', company: 'Empresa',
      companyOptional: 'Empresa (opcional)',
      venue: 'Empresa / Espaço', venueType: 'Tipo de espaço', location: 'Localização',
      service: 'Serviço', budget: 'Expectativa de investimento',
      message: 'Mensagem',
      messagePlaceholder: 'Conta-nos o que pretendes...',
      consentPrefix: 'Li e aceito a',
      privacyLink: 'Política de Privacidade',
      submit: 'Enviar Mensagem',
      sending: 'A enviar...',
      successTitle: 'Mensagem enviada!',
      successText: 'Obrigado pelo contacto. Vamos responder o mais brevemente possível.',
      errorText: 'Algo correu mal. Tenta novamente ou contacta-nos diretamente.',
      select: 'Selecionar...',
      services: ['Fotografia', 'Vídeo', 'Marketing', 'Website', 'Outro'],
      budgets: ['50€ – 500€', '500€ – 1.000€', '1.000€ – 3.000€', '3.000€ – 5.000€', '5.000€ – 10.000€', '10.000€ +'],
      venueTypes: ['Karting', 'Surf', 'Parque de Diversões', 'Zoológico', 'Oceanário', 'Parque Aquático', 'Parque de Aventura', 'Turismo', 'Outro'],
    },
  },
  footer: {
    tagline: 'Media. Souvenir. Experience.',
    navigation: 'Navegação',
    legal: 'Legal',
    follow: 'Segue-nos',
    rights: '© F&L Group — Todos os direitos reservados.',
  },
  cookie: {
    title: 'Cookies',
    text: 'Utilizamos cookies essenciais para o funcionamento do website e, com o teu consentimento, cookies de análise para melhorar a tua experiência.',
    accept: 'Aceitar',
    refuse: 'Recusar',
    configure: 'Configurar',
    save: 'Guardar preferências',
    essential: 'Essenciais',
    essentialDesc: 'Necessários ao funcionamento do website. Sempre ativos.',
    analytics: 'Análise',
    analyticsDesc: 'Ajudam-nos a compreender como o website é utilizado.',
    alwaysOn: 'Sempre ativos',
  },
  legal: {
    privacy: {
      title: 'Política de Privacidade',
      updated: 'Última atualização: 6 de outubro de 2026',
      sections: [
        { h: '1. Responsável pelo tratamento de dados', p: 'Nome legal da empresa: [a preencher] · NIF: [a preencher] · Morada: [a preencher] · Email: geral@flgroup.pt · Responsável pelo tratamento dos dados: [a preencher].' },
        { h: '2. Dados recolhidos', p: 'Formulários de contacto: recolhemos os dados que o utilizador fornece voluntariamente — nome, email, telefone (opcional), empresa/espaço (opcional), serviço pretendido, expectativa de investimento (formulário F&L Media), tipo de espaço e localização (formulário F&L Souvenir) e o conteúdo da mensagem. Estes dados ficam guardados numa base de dados segura, são enviados por email para a equipa da marca correspondente e originam um email automático de confirmação para o utilizador. Assistente virtual Íris: as mensagens escritas no chat são transmitidas a um fornecedor de inteligência artificial (OpenAI) apenas para gerar a resposta e não ficam guardadas — cada conversa é processada no momento e não é registada. Recomendamos que não partilhe dados sensíveis no chat. Para prevenção de abuso, o endereço IP é utilizado temporariamente para limitar o número de mensagens, sem registo permanente.' },
        { h: '3. Finalidades do tratamento', p: 'Os dados recolhidos destinam-se exclusivamente a responder a pedidos de contacto, elaborar propostas comerciais, gerir eventuais parcerias e prestar o serviço da assistente virtual. Não utilizamos os dados para fins de marketing sem consentimento prévio.' },
        { h: '4. Fundamento jurídico', p: 'O tratamento dos dados baseia-se no consentimento do titular (art. 6.º, n.º 1, al. a) do RGPD), manifestado através da aceitação desta política no momento do envio do formulário.' },
        { h: '5. Conservação dos dados', p: 'Os dados de pedidos de contacto e orçamentos que não avancem são eliminados automaticamente 6 meses após o último contacto. Os dados de clientes e os necessários ao cumprimento de obrigações contratuais, fiscais ou legais (por exemplo, dados de faturação, conservados durante os prazos previstos na legislação fiscal) são mantidos durante os prazos legalmente exigidos. As conversas com a assistente virtual Íris não são conservadas.' },
        { h: '6. Partilha de dados', p: 'Os dados não são vendidos nem partilhados para fins de marketing. São transmitidos apenas aos fornecedores estritamente necessários ao funcionamento do serviço: o fornecedor de email que entrega as notificações e confirmações dos formulários, e o fornecedor de inteligência artificial (OpenAI) que processa as mensagens do chat da Íris no momento, sem as guardar. Qualquer outra partilha só ocorre quando exigida por lei.' },
        { h: '7. Direitos dos titulares', p: 'Nos termos do RGPD, o titular tem direito de acesso, retificação, apagamento, limitação, portabilidade e oposição ao tratamento dos seus dados. Para exercer estes direitos, contacte-nos através de geral@flgroup.pt. Poderá ainda apresentar reclamação à CNPD — Comissão Nacional de Proteção de Dados.' },
        { h: '8. Cookies', p: 'Para informação detalhada sobre a utilização de cookies neste website, consulte a nossa Política de Cookies.' },
        { h: '9. Alterações a esta política', p: 'Esta política pode ser atualizada periodicamente. A versão em vigor é a publicada nesta página, com a respetiva data de atualização.' },
      ],
    },
    cookies: {
      title: 'Política de Cookies',
      updated: 'Última atualização: 1 de outubro de 2026',
      sections: [
        { h: '1. O que são cookies', p: 'Cookies são pequenos ficheiros de texto armazenados no dispositivo do utilizador quando visita um website, permitindo o seu funcionamento e, quando consentido, a recolha de informação estatística.' },
        { h: '2. Cookies que utilizamos', p: 'Cookies essenciais: necessários ao funcionamento técnico do website (por exemplo, preferência de idioma e consentimento de cookies). Não requerem consentimento. Cookies de análise: [a preencher caso sejam utilizadas ferramentas de análise — atualmente não estão ativas].' },
        { h: '3. Gestão do consentimento', p: 'Ao aceder ao website, o utilizador pode aceitar, recusar ou configurar os cookies não essenciais através do banner de consentimento. Pode alterar a sua decisão a qualquer momento.' },
        { h: '4. Como desativar cookies', p: 'O utilizador pode ainda gerir ou eliminar cookies através das definições do seu navegador. A desativação de cookies essenciais pode afetar o funcionamento do website.' },
        { h: '5. Contactos', p: 'Para questões relacionadas com esta política, contacte-nos através de geral@flgroup.pt.' },
      ],
    },
    terms: {
      title: 'Termos e Condições',
      updated: 'Última atualização: 1 de outubro de 2026',
      sections: [
        { h: '1. Identificação', p: 'Este website é propriedade de [nome legal da empresa a preencher], NIF [a preencher], com sede em [morada a preencher], doravante designada por F&L Group.' },
        { h: '2. Objeto', p: 'Os presentes termos regulam a utilização deste website, que tem caráter informativo e comercial, apresentando os serviços das marcas F&L Media e F&L Souvenir.' },
        { h: '3. Propriedade intelectual', p: 'Todos os conteúdos deste website — incluindo textos, fotografias, vídeos, logótipos e grafismo — são propriedade da F&L Group ou utilizados com autorização, não podendo ser reproduzidos sem consentimento prévio.' },
        { h: '4. Responsabilidade', p: 'A F&L Group esforça-se por manter a informação do website atualizada e correta, não podendo, contudo, garantir a ausência de erros ou interrupções de disponibilidade.' },
        { h: '5. Ligações externas', p: 'Este website pode conter ligações para websites de terceiros, pelos quais a F&L Group não se responsabiliza.' },
        { h: '6. Lei aplicável', p: 'Os presentes termos regem-se pela lei portuguesa. Para resolução de litígios é competente o foro de [a preencher].' },
      ],
    },
  },
  notFound: { title: 'Página não encontrada', text: 'A página que procuras não existe.', cta: 'Voltar ao início' },
  chat: {
    title: 'Íris',
    subtitle: 'Assistente de IA · F&L Group',
    welcome: 'Olá! Sou a Íris, a assistente virtual da F&L Group. Posso ajudar-te a conhecer os nossos serviços e a encontrar a informação que procuras. Como posso ajudar?',
    disclaimer: 'Sou uma assistente de IA. Não partilhes dados sensíveis — as conversas não são guardadas.',
    whatsapp: 'Falar no WhatsApp',
    placeholder: 'Escreve a tua mensagem...',
    send: 'Enviar',
    open: 'Falar com a Íris',
    minimize: 'Minimizar',
    close: 'Fechar conversa',
    suggestions: ['O que faz a F&L Media?', 'Como funciona a F&L Souvenir?', 'Quero pedir um orçamento', 'Como posso contactar-vos?'],
    offline: 'De momento não consigo responder. Contacta-nos diretamente através de geral@flgroup.pt.',
    rateLimited: 'Atingiste o limite de mensagens por hora. Para continuares a conversa, contacta-nos através de geral@flgroup.pt.',
  },
};

export default pt;
